import React from 'react';
import { Box, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import BassModeSelector from './BassModeSelector';
import { SELECTED_BG, SELECTED_FG, SELECTED_BG_HOVER } from '../config/uiTheme';

// Voicing options shown in the chord-config popover (same values the bottom-bar
// button cycles through: 1 = drone, 3 = triad, 7 = 7th chord).
const CHORD_OPTIONS = [
  { value: '1', label: '1', caption: 'Drone' },
  { value: '3', label: '3', caption: 'Triad' },
  { value: '7', label: '7', caption: '7th' },
];

const SECTION_LABEL_SX = {
  fontSize: '0.7rem',
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: 'rgba(255, 255, 255, 0.45)',
  mb: 1,
};

// Body of the long-press / "more" popover anchored on the chord-extension button.
// Groups the voicing (1/3/7) and the bass mode (No / Static / Follow chords).
const ChordConfigPanel = ({ chordExtension, onChordExtensionChange, bassMode, onBassModeChange }) => (
  <Box sx={{ p: 2, width: 300, bgcolor: '#15151A' }}>
    <Typography sx={SECTION_LABEL_SX}>Chord</Typography>
    <ToggleButtonGroup
      exclusive
      fullWidth
      value={chordExtension}
      onChange={(e, next) => { if (next) onChordExtensionChange(next); }}
      sx={{
        '& .MuiToggleButton-root': {
          color: 'rgba(255, 255, 255, 0.6)',
          borderColor: 'rgba(255, 255, 255, 0.12)',
          py: 0.75,
          '&.Mui-selected': {
            color: SELECTED_FG,
            backgroundColor: SELECTED_BG,
            '&:hover': { backgroundColor: SELECTED_BG_HOVER },
          },
        },
      }}
    >
      {CHORD_OPTIONS.map((o) => (
        <ToggleButton key={o.value} value={o.value} aria-label={o.caption}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1 }}>
            <Box component="span" sx={{ fontSize: '1.4rem', fontWeight: 800 }}>{o.label}</Box>
            <Box component="span" sx={{ fontSize: '0.62rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', mt: 0.5 }}>
              {o.caption}
            </Box>
          </Box>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>

    <Typography sx={{ ...SECTION_LABEL_SX, mt: 2 }}>Bass</Typography>
    <BassModeSelector value={bassMode} onChange={onBassModeChange} />
  </Box>
);

export default ChordConfigPanel;
